import React from 'react';
import { usePriceRowContext } from '../../../price-row-context';
import {
  priceLabelStylingType,
  priceLabel,
} from 'src/components/price-label/types';
import { CurrentCampaign } from 'src/areas/product/types';
import { PriceDisplayEnum } from 'src/components/price-list/types';
import { PricePrice } from 'src/types';
import * as S from './styles';

interface IPriceLabel {
  price?: PricePrice | null;
  activeCampaign?: CurrentCampaign | null;
}

const getPriceLabelStyling = (
  isCampaign: boolean,
  storeIsFeatured?: boolean | null
): priceLabelStylingType => {
  if (!storeIsFeatured) return priceLabel.LIGHTEN;
  if (isCampaign) return priceLabel.CAMPAIGN;
  return priceLabel.PRIMARY;
};

export const PriceLabel: React.FC<IPriceLabel> = props => {
  const { price, activeCampaign } = props;
  const { priceDisplay, offer } = usePriceRowContext();
  const { featured } = offer;

  if (!price) {
    return null;
  }

  const mainPrice =
    priceDisplay === PriceDisplayEnum.PRICE_INCLUDES_SHIPPING &&
    price.inclShipping
      ? price.inclShipping
      : price.exclShipping;

  return (
    <>
      {mainPrice && (
        <S.PriceLabel
          value={mainPrice}
          styling={getPriceLabelStyling(Boolean(activeCampaign), featured)}
        />
      )}
    </>
  );
};
